export var DefaultCurrentRoute = {
    Url: "",
    State: null
};
//# sourceMappingURL=currentRoute.model.js.map